module.exports = __webpack_public_path__ + "img/logo.988c4e0c.png";